module.exports = __webpack_public_path__ + "img/744.1ac7db05.jpg";